// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-header {
  background: var(--bg-secondary);
  border-bottom: 2px solid var(--border-color);
  padding: 40px 20px;
  margin-bottom: 40px;
  transition: border-color 0.3s;
}

.article-header:hover {
  border-bottom-color: var(--accent-primary);
}

.article-header-content {
  padding: 0 1.5vw;
  margin: 0 auto;
}

@media (max-width: 1500px) {
  .article-header-content {
    padding-left: 0;
    padding-right: 0;
  }
}

@media (max-width: 1159.9px) {
  .article-header {
    max-width: 100%;
  }
}

@media (max-width: 600px) {
  .article-header {
    max-width: 100%;
  }
}

/* Tags */
.article-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.article-community-title {
  font-weight: 600;
  color: var(--accent-primary);
  margin-right: 4px;
}

.article-tag {
  display: inline-block;
  padding: 6px 12px;
  background: var(--bg-tertiary);
  color: var(--accent-primary);
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  border: 1px solid var(--border-color);
  transition: all 0.2s;
}

.article-tag:hover {
  background: var(--accent-primary);
  color: var(--bg-secondary);
  transform: translateY(-2px);
}

.article-community-tag {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 2px solid var(--accent-primary);
  font-weight: 700;
}

.article-community-tag:hover {
  background: var(--accent-primary);
  color: white;
}

/* Title */
.article-title {
  font-size: 2.8rem;
  font-weight: 700;
  line-height: 1.2;
  margin: 20px 0 24px;
  color: var(--text-primary);
  letter-spacing: -0.5px;
}

/* Reading metadata */
.article-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px 0;
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 20px;
  font-size: 0.95rem;
  color: var(--text-secondary);
}

.article-header .meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.article-header .meta-icon {
  font-size: 1.1rem;
}

.article-header .article-via-app {
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.article-header .article-via-app em {
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Author section */
.article-author {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  gap: 16px;
}

.article-header .author-link {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  flex: 1 1;
  min-width: 0;
}

.article-header .article-author-main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.article-header .author-avatar-menu {
  position: relative;
  flex-shrink: 0;
}

.article-header .author-avatar-trigger {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  border-radius: 10px;
}

.article-header .author-avatar-trigger:hover .author-avatar {
  transform: scale(1.05);
  border-color: var(--accent-primary);
}

.article-header .author-avatar-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 180px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  z-index: 20;
  overflow: hidden;
}

.article-header .author-avatar-dropdown button {
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  color: var(--text-primary);
  padding: 10px 12px;
  cursor: pointer;
}

.article-header .author-avatar-dropdown button:hover {
  background: var(--hover-bg);
}

.article-header .author-avatar {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  object-fit: cover;
  display: block;
  background-color: #ddd;
  flex-shrink: 0;
  border: 2px solid var(--border-color);
  transition: transform 0.2s, border-color 0.2s;
}

.article-header .author-link:hover .author-avatar {
  transform: scale(1.05);
  border-color: var(--accent-primary);
}

.article-header .author-name-link {
  text-decoration: none;
}

.article-header .author-name-link:hover strong {
  text-decoration: underline;
}

.article-header .author-info {
  min-width: 0;
}

.article-header .author-name {
  font-size: 1rem;
  color: var(--text-primary);
  font-weight: 600;
}

.article-header .author-name strong {
  color: var(--accent-primary);
}

.article-header .author-votes {
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin-top: 2px;
}

/* Share button */
.article-share-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
}

.article-share-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}

.article-share-btn svg {
  width: 18px;
  height: 18px;
}

/* Responsive */
@media (max-width: 1159.9px) {
  .article-header-content {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .article-header {
    padding: 24px 16px;
    margin-bottom: 24px;
  }

  .article-title {
    font-size: 2rem;
  }

  .article-meta {
    flex-direction: column;
    gap: 12px;
  }

  .article-author {
    flex-direction: column;
    align-items: flex-start;
  }

  .article-share-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Dark theme */
[data-theme="dark"] .article-header {
  background: var(--bg-secondary);
}

[data-theme="dark"] .article-tag {
  background: var(--bg-tertiary);
}

/* Article Post Actions */
.article-post-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--border-color);
}

.article-action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--bg-tertiary);
  border: 2px solid var(--border-color);
  color: var(--text-primary);
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.article-action-btn:hover {
  border-color: var(--accent-primary);
  background: var(--accent-primary);
  color: white;
  transform: translateY(-2px);
}

.article-action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.article-action-btn svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.article-action-btn.voted {
  border-color: var(--accent-primary);
  background: var(--bg-tertiary);
}

/* Vote Slider Popup */
.article-vote-slider-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  padding: 24px;
  z-index: 1000;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  min-width: 320px;
}

.article-header .slider-header {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 16px;
  text-align: center;
}

.article-header .slider-container {
  margin: 20px 0;
}

.article-header .vote-slider {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: var(--bg-tertiary);
  outline: none;
  cursor: pointer;
}

.article-header .vote-slider::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--accent-primary);
  cursor: pointer;
}

.article-header .vote-slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--accent-primary);
  cursor: pointer;
  border: none;
}

.article-header .slider-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.article-header .slider-actions button {
  flex: 1 1;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid var(--border-color);
}

.article-header .cancel-btn {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.article-header .cancel-btn:hover {
  border-color: var(--accent-primary);
}

.article-header .vote-btn:hover {
  opacity: 0.9;
}

.article-header .vote-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Action dropdown menu */
.article-header .action-dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.article-header .dropdown-toggle {
  font-size: 1.2rem;
  line-height: 1;
  padding: 8px 12px;
}

.article-header .action-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 6px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  z-index: 100;
  min-width: 170px;
  padding: 6px 0;
}

.article-header .action-dropdown-menu .dropdown-item {
  display: block;
  width: 100%;
  padding: 8px 14px;
  background: none;
  border: none;
  text-align: left;
  color: var(--text-secondary);
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  box-sizing: border-box;
  font-family: inherit;
}

.article-header .action-dropdown-menu .dropdown-item:hover {
  background: var(--hover-bg);
  color: var(--primary-color);
}

.article-header .action-dropdown-menu .dropdown-item.dropdown-item-disabled,
.article-header .action-dropdown-menu .dropdown-item.dropdown-item-disabled:hover {
  cursor: not-allowed;
  color: var(--text-tertiary);
  background: transparent;
  opacity: 0.8;
}

.article-header .copy-link-notice {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  padding: 6px 10px;
  border-radius: 8px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  color: var(--text-primary);
  white-space: nowrap;
  z-index: 110;
}
`, "",{"version":3,"sources":["webpack://./src/components/ArticleHeader/ArticleHeader.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,yCAAyC;EACzC,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,eAAe;AACf;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,wCAAwC;EACxC,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".article-header {\n  background: var(--bg-secondary);\n  border-bottom: 2px solid var(--border-color);\n  padding: 40px 20px;\n  margin-bottom: 40px;\n  transition: border-color 0.3s;\n}\n\n.article-header:hover {\n  border-bottom-color: var(--accent-primary);\n}\n\n.article-header-content {\n  padding: 0 1.5vw;\n  margin: 0 auto;\n}\n\n@media (max-width: 1500px) {\n  .article-header-content {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n@media (max-width: 1159.9px) {\n  .article-header {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 600px) {\n  .article-header {\n    max-width: 100%;\n  }\n}\n\n/* Tags */\n.article-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.article-community-title {\n  font-weight: 600;\n  color: var(--accent-primary);\n  margin-right: 4px;\n}\n\n.article-tag {\n  display: inline-block;\n  padding: 6px 12px;\n  background: var(--bg-tertiary);\n  color: var(--accent-primary);\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-decoration: none;\n  border: 1px solid var(--border-color);\n  transition: all 0.2s;\n}\n\n.article-tag:hover {\n  background: var(--accent-primary);\n  color: var(--bg-secondary);\n  transform: translateY(-2px);\n}\n\n.article-community-tag {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 2px solid var(--accent-primary);\n  font-weight: 700;\n}\n\n.article-community-tag:hover {\n  background: var(--accent-primary);\n  color: white;\n}\n\n/* Title */\n.article-title {\n  font-size: 2.8rem;\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 20px 0 24px;\n  color: var(--text-primary);\n  letter-spacing: -0.5px;\n}\n\n/* Reading metadata */\n.article-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding: 20px 0;\n  border-top: 1px solid var(--border-color);\n  border-bottom: 1px solid var(--border-color);\n  margin-bottom: 20px;\n  font-size: 0.95rem;\n  color: var(--text-secondary);\n}\n\n.article-header .meta-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n.article-header .meta-icon {\n  font-size: 1.1rem;\n}\n\n.article-header .article-via-app {\n  max-width: 260px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.article-header .article-via-app em {\n  font-style: italic;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Author section */\n.article-author {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 24px;\n  gap: 16px;\n}\n\n.article-header .author-link {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n  flex: 1;\n  min-width: 0;\n}\n\n.article-header .article-author-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.article-header .author-avatar-menu {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.article-header .author-avatar-trigger {\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  border-radius: 10px;\n}\n\n.article-header .author-avatar-trigger:hover .author-avatar {\n  transform: scale(1.05);\n  border-color: var(--accent-primary);\n}\n\n.article-header .author-avatar-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  min-width: 180px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n  z-index: 20;\n  overflow: hidden;\n}\n\n.article-header .author-avatar-dropdown button {\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: none;\n  color: var(--text-primary);\n  padding: 10px 12px;\n  cursor: pointer;\n}\n\n.article-header .author-avatar-dropdown button:hover {\n  background: var(--hover-bg);\n}\n\n.article-header .author-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 8px;\n  object-fit: cover;\n  display: block;\n  background-color: #ddd;\n  flex-shrink: 0;\n  border: 2px solid var(--border-color);\n  transition: transform 0.2s, border-color 0.2s;\n}\n\n.article-header .author-link:hover .author-avatar {\n  transform: scale(1.05);\n  border-color: var(--accent-primary);\n}\n\n.article-header .author-name-link {\n  text-decoration: none;\n}\n\n.article-header .author-name-link:hover strong {\n  text-decoration: underline;\n}\n\n.article-header .author-info {\n  min-width: 0;\n}\n\n.article-header .author-name {\n  font-size: 1rem;\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.article-header .author-name strong {\n  color: var(--accent-primary);\n}\n\n.article-header .author-votes {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  margin-top: 2px;\n}\n\n/* Share button */\n.article-share-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: var(--accent-primary);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.article-share-btn:hover {\n  opacity: 0.9;\n  transform: translateY(-2px);\n}\n\n.article-share-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Responsive */\n@media (max-width: 1159.9px) {\n  .article-header-content {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .article-header {\n    padding: 24px 16px;\n    margin-bottom: 24px;\n  }\n\n  .article-title {\n    font-size: 2rem;\n  }\n\n  .article-meta {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .article-author {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .article-share-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* Dark theme */\n[data-theme=\"dark\"] .article-header {\n  background: var(--bg-secondary);\n}\n\n[data-theme=\"dark\"] .article-tag {\n  background: var(--bg-tertiary);\n}\n\n/* Article Post Actions */\n.article-post-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 9px;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-color);\n}\n\n.article-action-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: var(--bg-tertiary);\n  border: 2px solid var(--border-color);\n  color: var(--text-primary);\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.article-action-btn:hover {\n  border-color: var(--accent-primary);\n  background: var(--accent-primary);\n  color: white;\n  transform: translateY(-2px);\n}\n\n.article-action-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.article-action-btn svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.article-action-btn.voted {\n  border-color: var(--accent-primary);\n  background: var(--bg-tertiary);\n}\n\n/* Vote Slider Popup */\n.article-vote-slider-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: var(--bg-secondary);\n  border: 2px solid var(--border-color);\n  border-radius: 12px;\n  padding: 24px;\n  z-index: 1000;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  min-width: 320px;\n}\n\n.article-header .slider-header {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.article-header .slider-container {\n  margin: 20px 0;\n}\n\n.article-header .vote-slider {\n  width: 100%;\n  height: 6px;\n  border-radius: 3px;\n  background: var(--bg-tertiary);\n  outline: none;\n  cursor: pointer;\n}\n\n.article-header .vote-slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--accent-primary);\n  cursor: pointer;\n}\n\n.article-header .vote-slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--accent-primary);\n  cursor: pointer;\n  border: none;\n}\n\n.article-header .slider-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.article-header .slider-actions button {\n  flex: 1;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 2px solid var(--border-color);\n}\n\n.article-header .cancel-btn {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.article-header .cancel-btn:hover {\n  border-color: var(--accent-primary);\n}\n\n.article-header .vote-btn:hover {\n  opacity: 0.9;\n}\n\n.article-header .vote-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Action dropdown menu */\n.article-header .action-dropdown-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.article-header .dropdown-toggle {\n  font-size: 1.2rem;\n  line-height: 1;\n  padding: 8px 12px;\n}\n\n.article-header .action-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 6px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n  border-radius: 8px;\n  z-index: 100;\n  min-width: 170px;\n  padding: 6px 0;\n}\n\n.article-header .action-dropdown-menu .dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 8px 14px;\n  background: none;\n  border: none;\n  text-align: left;\n  color: var(--text-secondary);\n  font-size: 13px;\n  cursor: pointer;\n  text-decoration: none;\n  white-space: nowrap;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.article-header .action-dropdown-menu .dropdown-item:hover {\n  background: var(--hover-bg);\n  color: var(--primary-color);\n}\n\n.article-header .action-dropdown-menu .dropdown-item.dropdown-item-disabled,\n.article-header .action-dropdown-menu .dropdown-item.dropdown-item-disabled:hover {\n  cursor: not-allowed;\n  color: var(--text-tertiary);\n  background: transparent;\n  opacity: 0.8;\n}\n\n.article-header .copy-link-notice {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  padding: 6px 10px;\n  border-radius: 8px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  font-size: 12px;\n  color: var(--text-primary);\n  white-space: nowrap;\n  z-index: 110;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
